module.exports = __webpack_public_path__ + "mainassets/img/graf4-2.6e4fc14f.svg";